import { h, Fragment} from 'preact';
import { useState } from 'preact/hooks';
import Markup from 'preact-markup';


export const DeepLinks = props => {
    try {
        const [deepLinks, getDeepLinks] = useState(props.deepLinks);
        if (!deepLinks || deepLinks.length == 0) {
            return (""); //defensive check
        }
        return (
            <div className="deeplinks-block">
                {deepLinks.map(dLink => {
                    if (dLink.url && dLink.name) {
                        return (
                            <div className="deeplink-block">
                                <div className="ae-subtitle-large result-title"><a href={dLink.url}><Markup markup={dLink.name} type="html" trim={false} className="ae-ellipsis-1"/></a></div>
                                {(dLink.snippet) ? <div><Markup markup={dLink.snippet} type="html" trim={false}  className="ae-line-clamp-2"/></div> : ""}
                            </div>
                        )
                    } else return ("");
                })}
            </div>
        )
    } catch (ex) {
        // do nothing for now
    }
    return ("");
}


